module.exports = __webpack_public_path__ + "img/5.bbf59288.jpg";